import React, { useState } from "react";
import { FaSearch, FaEye, FaUser } from "react-icons/fa";

/* ═══════════════════════════════════════════════════════
   REBRAND — Raleway · Yellow #fff000 · Black · White
═══════════════════════════════════════════════════════ */
const S = `
  @import url('https://fonts.googleapis.com/css2?family=Raleway:wght@400;500;600;700;800&display=swap');

  .ct-wrap * { box-sizing: border-box; font-family: 'Raleway', sans-serif; }

  .ct-toolbar {
    display: flex; align-items: center; gap: 10px;
    margin-bottom: 1.25rem; flex-wrap: wrap;
  }
  .ct-search {
    flex: 1; min-width: 240px;
    display: flex; align-items: center; gap: 10px;
    background: #000000; border: 1.5px solid rgba(255,255,255,.15);
    border-radius: 11px; padding: .65rem 1rem;
    transition: border-color .2s;
  }
  .ct-search:focus-within { border-color: #fff000; }
  .ct-search input { flex: 1; background: none; border: none; outline: none; color: #ffffff; font-size: .88rem; }
  .ct-search input::placeholder { color: #555; }

  .ct-filter select {
    background: #000000; border: 1.5px solid rgba(255,255,255,.15);
    border-radius: 11px; padding: .65rem 1rem;
    color: #cccccc; font-size: .84rem;
    outline: none; cursor: pointer; transition: border-color .2s;
  }
  .ct-filter select:focus { border-color: #fff000; }

  .ct-count-badge {
    display: inline-flex; align-items: center; justify-content: center;
    background: rgba(255,240,0,.12); border: 1px solid rgba(255,240,0,.3);
    color: #fff000; border-radius: 20px;
    padding: 4px 12px; font-size: .75rem; font-weight: 700;
    white-space: nowrap;
  }

  .ct-table-wrap {
    background: #000000; border: 1px solid rgba(255,255,255,.1);
    border-radius: 16px; overflow: hidden;
  }
  .ct-table { width: 100%; border-collapse: collapse; min-width: 640px; }
  .ct-table thead tr {
    background: #0d0d0d;
    border-bottom: 1px solid rgba(255,240,0,.25);
  }
  .ct-table thead th {
    padding: .9rem 1.25rem;
    font-size: .65rem; font-weight: 700;
    letter-spacing: .1em; text-transform: uppercase;
    color: #999; text-align: left; white-space: nowrap;
  }
  .ct-table tbody tr {
    border-bottom: 1px solid rgba(255,255,255,.06);
    transition: background .12s; cursor: pointer;
  }
  .ct-table tbody tr:last-child { border-bottom: none; }
  .ct-table tbody tr:hover { background: rgba(255,240,0,.04); }
  .ct-table td {
    padding: .95rem 1.25rem;
    font-size: .84rem; color: #cccccc;
    vertical-align: middle;
  }

  .ct-avatar {
    width: 38px; height: 38px; border-radius: 50%;
    object-fit: cover; border: 2px solid rgba(255,240,0,.35);
    flex-shrink: 0;
  }
  .ct-avatar-fallback {
    width: 38px; height: 38px; border-radius: 50%;
    background: #fff000;
    display: flex; align-items: center; justify-content: center;
    font-weight: 800; font-size: .9rem; color: #000000;
    flex-shrink: 0;
  }
  .ct-name-cell { display: flex; align-items: center; gap: 10px; }
  .ct-name { font-weight: 700; color: #ffffff; font-size: .88rem; }
  .ct-profession { font-size: .72rem; color: #888; margin-top: 1px; }

  .ct-service-tag {
    display: inline-block;
    background: rgba(255,255,255,.06); border: 1px solid rgba(255,255,255,.12);
    color: #cccccc; border-radius: 20px;
    padding: 3px 10px; font-size: .74rem;
  }

  .ct-phone { font-size: .82rem; color: #cccccc; }

  .ct-pill {
    display: inline-flex; align-items: center; gap: 5px;
    border-radius: 20px; padding: 3px 10px;
    font-size: .68rem; font-weight: 700; white-space: nowrap;
  }
  .ct-pill-pending    { background: rgba(255,240,0,.12);  color: #fff000; border: 1px solid rgba(255,240,0,.3); }
  .ct-pill-approved   { background: rgba(255,255,255,.1); color: #ffffff; border: 1px solid rgba(255,255,255,.25); }
  .ct-pill-inactive   { background: rgba(255,255,255,.05); color: #888; border: 1px solid rgba(255,255,255,.1); }
  .ct-pill-suspended  { background: rgba(255,255,255,.05); color: #cccccc; border: 1px solid rgba(255,255,255,.15); text-decoration: line-through; }
  .ct-pill-rejected   { background: rgba(255,255,255,.04); color: #666; border: 1px solid rgba(255,255,255,.08); }

  .ct-login { font-size: .78rem; color: #cccccc; }
  .ct-login.recent { color: #fff000; }
  .ct-login.never  { color: #555; font-style: italic; }

  .ct-view-btn {
    display: inline-flex; align-items: center; gap: 6px;
    padding: 6px 13px; border-radius: 7px;
    font-size: .78rem; font-weight: 700;
    cursor: pointer; border: 1px solid rgba(255,240,0,.3);
    background: rgba(255,240,0,.08); color: #fff000;
    transition: all .15s; white-space: nowrap;
  }
  .ct-view-btn:hover { background: rgba(255,240,0,.18); }

  .ct-empty {
    display: flex; flex-direction: column; align-items: center; justify-content: center;
    padding: 4rem 2rem; gap: .75rem;
  }
  .ct-empty-icon {
    width: 56px; height: 56px; border-radius: 50%;
    background: rgba(255,240,0,.08); border: 1px solid rgba(255,240,0,.25);
    display: flex; align-items: center; justify-content: center;
    color: #fff000; font-size: 1.3rem;
  }
  .ct-empty h4 { font-size: 1rem; font-weight: 800; color: #ffffff; margin: 0; }
  .ct-empty p  { font-size: .82rem; color: #888; margin: 0; }

  @media (max-width: 900px) { .ct-table-wrap { overflow-x: auto; } }
`;

function timeSince(dateStr) {
  if (!dateStr) return null;
  const diff  = Date.now() - new Date(dateStr).getTime();
  const mins  = Math.floor(diff / 60000);
  const hours = Math.floor(diff / 3600000);
  const days  = Math.floor(diff / 86400000);
  if (mins < 2)   return "Just now";
  if (mins < 60)  return `${mins}m ago`;
  if (hours < 24) return `${hours}h ago`;
  if (days === 1) return "Yesterday";
  if (days < 7)   return `${days}d ago`;
  return new Date(dateStr).toLocaleDateString("en-KE", { day: "numeric", month: "short" });
}
function isRecent(dateStr, withinDays = 3) {
  if (!dateStr) return false;
  return Date.now() - new Date(dateStr).getTime() < 86400000 * withinDays;
}

/**
 * Lean craftsmen table. All the depth (profile %, missing fields, portfolio,
 * marketplace stats, verification, activity log) now lives in
 * CraftsmanDetailView — reached via the "View" button — rather than
 * cluttering this table. This is what keeps the table scannable at scale.
 */
export default function CraftsmenTable({
  list = [],
  filterValue = "",
  setFilterValue,
  isPending = false,
  getImageUrl,
  isCraftsmanApproved,
  onView,           // (craftsman) => void — opens the detail control center
  statusLabelFor,   // optional (craftsman) => string, for the Status column when not pending
}) {
  const [serviceFilter, setServiceFilter] = useState("");

  const getServiceName = (c) =>
    c.primary_service || c.services?.[0]?.name || c.services?.[0]?.service_name || null;

  const query = filterValue.toLowerCase();
  const services = Array.from(new Set(list.map(getServiceName).filter(Boolean)));

  const filtered = list.filter(c => {
    const matchQuery = !query ||
      (c.full_name || "").toLowerCase().includes(query) ||
      (c.company_name || "").toLowerCase().includes(query) ||
      (c.phone || c.phone_number || "").toLowerCase().includes(query) ||
      (c.email || c.user?.email || "").toLowerCase().includes(query);
    const matchService = !serviceFilter || getServiceName(c) === serviceFilter;
    return matchQuery && matchService;
  });

  const getInitial = (name) => (name || "?").charAt(0).toUpperCase();

  const getStatusPill = (c) => {
    if (isPending) return <span className="ct-pill ct-pill-pending">Pending</span>;
    if (statusLabelFor) {
      const label = statusLabelFor(c);
      const cls = {
        Active: "ct-pill-approved",
        Suspended: "ct-pill-suspended",
        Rejected: "ct-pill-rejected",
        Inactive: "ct-pill-inactive",
      }[label] || "ct-pill-inactive";
      return <span className={`ct-pill ${cls}`}>{label}</span>;
    }
    const approved = isCraftsmanApproved(c);
    if (!approved) return <span className="ct-pill ct-pill-rejected">Rejected</span>;
    return c.is_active
      ? <span className="ct-pill ct-pill-approved">Active</span>
      : <span className="ct-pill ct-pill-inactive">Inactive</span>;
  };

  return (
    <div className="ct-wrap">
      <style>{S}</style>

      {/* Toolbar: unified search + service filter */}
      <div className="ct-toolbar">
        <div className="ct-search">
          <FaSearch style={{ color: "#555", fontSize: ".82rem", flexShrink: 0 }} />
          <input
            placeholder="Search name, phone, email or business…"
            value={filterValue}
            onChange={e => setFilterValue(e.target.value)}
          />
          {filterValue && (
            <span onClick={() => setFilterValue("")} style={{ color: "#888", cursor: "pointer", fontSize: ".78rem" }}>
              Clear
            </span>
          )}
        </div>

        {services.length > 0 && (
          <div className="ct-filter">
            <select value={serviceFilter} onChange={e => setServiceFilter(e.target.value)}>
              <option value="">All Services</option>
              {services.map(s => <option key={s} value={s}>{s}</option>)}
            </select>
          </div>
        )}

        <span className="ct-count-badge">{filtered.length} craftsmen</span>
      </div>

      <div className="ct-table-wrap">
        {filtered.length === 0 ? (
          <div className="ct-empty">
            <div className="ct-empty-icon"><FaUser /></div>
            <h4>{filterValue || serviceFilter ? "No results found" : "No craftsmen here"}</h4>
            <p>{filterValue || serviceFilter ? "Try a different search or filter." : isPending ? "No craftsmen are awaiting approval." : "No craftsmen in this category."}</p>
          </div>
        ) : (
          <table className="ct-table">
            <thead>
              <tr>
                <th>Craftsman</th>
                <th>Service</th>
                <th>Phone</th>
                <th>Status</th>
                {!isPending && <th>Last Login</th>}
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {filtered.map(c => {
                const service = getServiceName(c);
                const imgSrc  = getImageUrl(c.profile);
                const phone   = c.phone || c.phone_number || "—";
                const lastLoginRaw = c.last_login;

                return (
                  <tr key={c.id} onClick={() => onView(c)}>
                    <td>
                      <div className="ct-name-cell">
                        {imgSrc ? (
                          <img src={imgSrc} alt={c.full_name} className="ct-avatar"
                            onError={e => { e.target.style.display = "none"; }} />
                        ) : (
                          <div className="ct-avatar-fallback">{getInitial(c.full_name)}</div>
                        )}
                        <div>
                          <div className="ct-name">{c.company_name || c.full_name || "—"}</div>
                          {c.company_name && <div className="ct-profession">{c.full_name}</div>}
                        </div>
                      </div>
                    </td>

                    <td>
                      {service
                        ? <span className="ct-service-tag">{service}</span>
                        : <span style={{ color: "#444" }}>—</span>
                      }
                    </td>

                    <td><span className="ct-phone">{phone}</span></td>

                    <td>{getStatusPill(c)}</td>

                    {!isPending && (
                      <td>
                        <span className={`ct-login${isRecent(lastLoginRaw) ? " recent" : !lastLoginRaw ? " never" : ""}`}>
                          {timeSince(lastLoginRaw) || "Never"}
                        </span>
                      </td>
                    )}

                    <td onClick={e => e.stopPropagation()}>
                      <button className="ct-view-btn" onClick={() => onView(c)}>
                        <FaEye size={11} /> View
                      </button>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
